import { useRef } from 'react'
import { t } from '$i18n'
import { Label } from '$common/label'
import { TextInput } from '$common/input'
import { ErrorOutlinedButton } from '$common/buttons/error-outlined-button'
import { PrimaryButton } from '$common/buttons'
import { SelectDateTime } from '$common/select-date-time/select-date-time'
import { Alert } from '$common/input/alert'
import { ButtonsContainer, FormContainer } from '../style-components'

interface Props {
  startDate: Date
  endDate: Date
  onChangeDate: (date: Date) => void
  selectedDate: Date
  title: string
  onChangeTitle: (title: string) => void
  onDelete: () => void
  onConfirm: () => void
  titleError: string
  titlePlaceholder?: string
}

export function EditScheduleForm({
  startDate,
  endDate,
  onChangeDate,
  selectedDate,
  title,
  onChangeTitle,
  onDelete,
  onConfirm,
  titleError,
  titlePlaceholder,
}: Props) {
  const startRef = useRef(startDate)
  const endRef = useRef(endDate)
  return (
    <>
      <FormContainer>
        <Label
          typographyProps={{ variant: 'subtitle3' }}
          title={t('chooseHallCallTimeModal.title')}
          inParentheses={t('chooseHallCallTimeModal.optional')}
        />
        <TextInput
          value={title}
          onChange={onChangeTitle}
          placeholder={
            titlePlaceholder || t('chooseHallCallTimeModal.titlePlaceholder')
          }
          rootSx={{ mb: !titleError ? '24px' : '0' }}
        />
        {titleError && (
          <Alert variant="error" text={titleError} sxStyle={{ mb: '24px' }} />
        )}
        <SelectDateTime
          labelProps={{
            typographyProps: {
              variant: 'subtitle3',
            },
          }}
          value={selectedDate}
          startDate={startRef.current}
          endDate={endRef.current}
          label={t('chooseHallCallTimeModal.startTime')}
          onSelect={onChangeDate}
          drawerTitle={t('chooseHallCallTimeModal.selectStartTime')}
          selectButtonSx={{ mb: '24px' }}
        />
      </FormContainer>
      <ButtonsContainer sx={{ gap: '8px' }}>
        <ErrorOutlinedButton
          sx={{ height: '48px', flexGrow: '1', width: '50%' }}
          text={t('common.remove')}
          onClick={onDelete}
        />
        <PrimaryButton
          text={t('common.save')}
          sx={{ height: '48px', flexGrow: '1', width: '50%' }}
          onClick={onConfirm}
        />
      </ButtonsContainer>
    </>
  )
}
